import { push } from 'react-router-redux'
import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'

// Action
export const REDIRECT_TO_ERROR = 'REDIRECT_TO_ERROR'

// Action Helper
export const redirectToError = (errorMessageType) => ({ type: REDIRECT_TO_ERROR, payload: errorMessageType })

// Epic
export const redirectToErrorEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(REDIRECT_TO_ERROR),
    map(action => {
      return push(`/error/${action.payload}`)
    })
  )



// WEBPACK FOOTER //
// ./src/store/redirectToError.js